import React from "react";

import {LoginWithRouter} from './components/Login'
import {Navigation} from './components/Navigation';
import {Summary} from './components/Summary';
import {ChartFilterFormWithRouter} from './components/ChartFilterForm';
import {Footer} from './components/Footer';
import {SecuredSection} from './components/LoginRequired';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect,
} from "react-router-dom";


import './App.css';
import {IndicatorPerfSummary} from "./components/indicator/IndicatorPerfSummary";
import {Generator} from "./components/generate/Generate";

function App() {

  return (
     <div className="App" >
        <div className="App-header" >
          <Router>
              <Switch>
                      <Route path="/login" />

                      <Route path="/:runContext/:subNav" children={<Navigation />}/>
                      <Route path="/:runContext" children={<Navigation />}/>
              </Switch>
              <Switch>
                  <Route path={`/generate`}>
                      <SecuredSection/>
                      <Generator  style={{"height":"100%"}}/>
                  </Route>
                  <Route path={`/:runContext/chart`}>
                      <SecuredSection/>
                      <ChartFilterFormWithRouter  style={{"height":"100%"}}/>
                  </Route>
                  <Route path={`/performance/summary`}>
                      <SecuredSection/>
                      <IndicatorPerfSummary />
                  </Route>
                  <Route path={`/:runContext/summary`}>
                      <SecuredSection/>
                      <Summary />
                  </Route>
                  <Route path="/login">
                      <LoginWithRouter/>
                  </Route>
                  <Route path={`/:runContext`}>
                     Select a topic
                  </Route>
                  <Route>
                      <Redirect to="/login" />
                  </Route>
              </Switch>
          </Router>
          <div style={{"height":"80px"}}> &nbsp;</div>
      </div>
        <div className="App-footer">
            <Footer/>
        </div>
    </div>
  );
}



export default App;
